class Validator {
  validateEmpty(value) {
    if (value === "") {
      return false;
    } else {
      return true;
    }
  }
  validateEmail(value) {
    const pattern = new RegExp(
      /^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm
    );
    if (pattern.test(value) === true) {
      return true;
    } else {
      return false;
    }
  }

  validateMinLength(length, value) {
    if (value.length > length) {
      return false;
    } else {
      return true;
    }
  }

  validatePassword(
    pass,
    max,
    min,
    digitPattern,
    upperCase,
    lowerCase,
    specialPattern
  ) {
    let specailCharPatten = new RegExp(/[!\"#$%&'()*+,-./:;<=>?@\\^_`|~]/gm);
    const UpperCasePatten = new RegExp(/[A-Z ]/gm);
    const lowerCasePatten = new RegExp(/[a-z ]/gm);
    const digitCasePatten = new RegExp(/[0-9 ]/gm);

    let error = [];
    let newMessage=[{type:"min",message:`  يجب أن لاتقل   كلمة السر  عن${min} رموز`,error:false,visiblity:true},
    {type:"max",message:`  يجب أن لاتكون    كلمة السر  أكبر من${max} رمز`,error:false,visiblity:true},
    {type:"upper-case",message:`يجب أن تحتوي كلمة السر على حروف كبيرة`,error:false,visiblity:upperCase},
    {type:"lower-case",message:`يجب أن تحتوي كلمة السر على حروف صغيرة`,error:false,visiblity:lowerCase},
    {type:"symboles",message:`يجب أن تحتوي كلمة السر على رموز `,error:false,visiblity:specialPattern},
    {type:"number",message:`يجب أن تحتوي كلمة السر على أرقام `,error:false,visiblity:digitPattern}
  ]
    if(min!=null){
   
      let message2={}
    if (pass&&pass.length < min) {
      newMessage.filter(i=>i.type=="min").map(i=>{i.error=true})
      // message2={type:"min",message:`  يجب أن لاتقل   كلمة السر  عن${min} رموز`,error:true}
    }
    else{
      newMessage.filter(i=>i.type=="min").map(i=>{i.error=false})
      // message2={type:"min",message:`  يجب أن لاتقل   كلمة السر  عن${min} رموز`,error:false}
    }
    error.push(message2)

  }

   if(max!=null){
    let message2={}

    if (pass&&pass.length > max) {
      newMessage.filter(i=>i.type=="max").map(i=>{i.error=true})
      // message2={type:"max",message:`  يجب أن لاتكون    كلمة السر  أكبر من${max} رمز`,error:true}
    }
    else{
      newMessage.filter(i=>i.type=="max").map(i=>{i.error=false})
      // message2={type:"max",message:`  يجب أن لاتكون    كلمة السر  أكبر من${max} رمز`,error:false}
    }
    error.push(message2)
    // return error;
  }
    if (upperCase) {
      let message2={}
      if (!UpperCasePatten.test(pass)) {
        newMessage.filter(i=>i.type=="upper-case").map(i=>{i.error=true})
        // message2={type:"upper-case",message:`يجب أن تحتوي كلمة السر على حروف كبيرة`,error:true}
      }
      else{
        newMessage.filter(i=>i.type=="upper-case").map(i=>{i.error=false})
        // message2={type:"upper-case",message:`يجب أن تحتوي كلمة السر على حروف كبيرة`,error:false}

      }
      error.push(message2)
      // return error;
    }
    if(lowerCase){
      let message2={}
    // password must contains Lower Case
     if (!lowerCasePatten.test(pass)) {
      newMessage.filter(i=>i.type=="lower-case").map(i=>{i.error=true})
    //  message2={type:"lower-case",message:`يجب أن تحتوي كلمة السر على حروف صغيرة`,error:true}
    }
    else{
      newMessage.filter(i=>i.type=="lower-case").map(i=>{i.error=false})
      // message2={type:"lower-case",message:`يجب أن تحتوي كلمة السر على حروف صغيرة`,error:false}
    }
    error.push(message2)
    // return error 
  }
   if(specialPattern){
    let message2={}
     if (!specailCharPatten.test(pass)) {
      newMessage.filter(i=>i.type=="symboles").map(i=>{i.error=true})
      // message2={type:"symboles",message:`يجب أن تحتوي كلمة السر على رموز `,error:true}
    } 
    else{
      newMessage.filter(i=>i.type=="symboles").map(i=>{i.error=false})

      // message2={type:"symboles",message:`يجب أن تحتوي كلمة السر على رموز `,error:false}
    }
    error.push(message2)
    // return error
  } 
  
   if(digitPattern){
  let message2={}

  if (!digitCasePatten.test(pass)) {
    newMessage.filter(i=>i.type=="number").map(i=>{i.error=true})

    // message2={type:"number",message:`يجب أن تحتوي كلمة السر على أرقام `,error:true}
    } 
    else{
      newMessage.filter(i=>i.type=="number").map(i=>{i.error=false})
      // message2={type:"number",message:`يجب أن تحتوي كلمة السر على أرقام `,error:false}
    }
    error.push(message2)
  // return error
  }
  return newMessage
}

}

export default Validator;
